<div class="pure-g m-t-16" style="align-items: center">
  <div
    class="pure-g pure-u-md-18-24 pure-u-lg-19-24 pure-u-xl-20-24"
    style="overflow: auto; text-wrap: nowrap; display: flex; align-items: center"></div>
</div>

<div class="m-t-8 quick-filter-box">
  <div class="applied-filter-holder">
    @for (taggedFilter of taggedFilters; track taggedFilter.key) {
      <div class="m-r-4" style="white-space: nowrap">
        {{ taggedFilter.key }}
      </div>

      @if (taggedFilter.key == 'Shop Code' && isArrayType(taggedFilter.value)) {
        <app-tag-with-overflow
          [data]="getTaggedShopCodes()"
          [overflowCount]="2"
          [withaction]="true"
          [dismiss]="unselectShopCode()"></app-tag-with-overflow>
      } @else if (taggedFilter.key == 'Equipment Type' && isArrayType(taggedFilter.value) && getTaggedEquipmentType()) {
        @for (taggedEquipmentType of getTaggedEquipmentType(); track taggedEquipmentType) {
          <mc-tag
            class="m-r-4 extra-height"
            appearance="neutral-inverse"
            fit="small"
            withaction
            (click)="unselectSpecificFilter(taggedFilter, getTaggedEquipmentType().indexOf(taggedEquipmentType))"
            >{{ getTaggedFilterValue(taggedFilter, getTaggedEquipmentType().indexOf(taggedEquipmentType)) }}</mc-tag
          >
        }
      } @else if (taggedFilter.key == 'Expiry Date' && getTaggedExpiryDate()) {
        <mc-tag
          class="m-r-4 extra-height"
          appearance="neutral-inverse"
          fit="small"
          withaction
          (click)="unselectSpecificFilter(taggedFilter)"
          (keydown.enter)="unselectSpecificFilter(taggedFilter)"
          >{{ getTaggedFilterValue(taggedFilter) }}</mc-tag
        >
      } @else if (taggedFilter.key == 'Effective Date') {
        <mc-tag
          class="m-r-4 extra-height"
          appearance="neutral-inverse"
          fit="small"
          withaction
          (click)="unselectSpecificFilter(taggedFilter)"
          (keydown.enter)="unselectSpecificFilter(taggedFilter)"
          >{{ getTaggedFilterValue(taggedFilter) }}</mc-tag
        >
      } @else {
        <mc-tag
          class="m-r-4 extra-height"
          appearance="neutral-inverse"
          fit="small"
          withaction
          (click)="unselectSpecificFilter(taggedFilter)"
          (keydown.enter)="unselectSpecificFilter(taggedFilter)"
          >{{ getTaggedFilterValue(taggedFilter) }}</mc-tag
        >
      }
    }
    @if (taggedFilters.length > 0) {
      <a>
        <mc-button class="clear-btn" variant="plain" appearance="primary" fit="small" padding="default" (click)="clearAllSelectedFilters()">
          Clear All
        </mc-button>
      </a>
    }
  </div>
  <div class="utility-buttons">
    @if (authPolicies.canViewShopContract) {
      <mc-button
        class="utility-button"
        label="Button"
        variant="filled"
        appearance="neutral"
        fit="medium"
        [loading]="isDownload"
        icon="tray-arrow-down"
        hiddenlabel
        padding="default"
        (click)="onDownload()"
        (keydown)="onDownload()">
      </mc-button>
    }

    <mc-button
      class="utility-button-inner"
      slot="trigger"
      label="Button"
      icon="sliders-horizontal"
      variant="filled"
      appearance="neutral"
      hiddenlabel
      padding="default"
      fit="medium"
      (click)="showAdvanceFiltersModal()"
      (keydown)="showAdvanceFiltersModal()">
    </mc-button>
  </div>

  <mc-modal
    backdropcloseactiondisabled
    [open]="showAdvanceFilters"
    (closed)="closeAdvanceFiltersModal()"
    heading="Filters"
    fit="small"
    dimension="large">
    <app-labour-rates-advance-filter
      [labourRatesFilterForm]="filterFormGroup.controls.labourRatesFilterForm"></app-labour-rates-advance-filter>
  </mc-modal>
</div>
